$(document).ready(function () {

    //
    $('.checkout input[type=radio]').on('change', function () {

        payment_type = $(this).val();

        $('[data-payment-type]').slideUp();

        $('[data-payment-type=' + payment_type + ']').slideDown();

        $('[data-payment-type]').find('input').val('');

    });

    //
    var default_apprise_options = {
        buttons: {

            checkout: {
                text: 'Okay, I\'ll fix it',
                className: 'main',
                action: function (e) {
                    Apprise('close');
                }
            }
        }
    };

    $('.js-pay-now').on('click', function (e) {

        console.log('Pay now clicked');

        e.preventDefault();

        var button = $(this);
        var msg = '';
        var valid = true;
        var error_msg = '';
        var form = $('.js-checkout-form');

        form.checkRequiredFields();
        
        if ($('.js-payment-type:checked').val() == 1) {

            console.log('Is card payment');

            //Card validation
            $('.required.ghost').each(function () {
                if (!$(this).val()) {
                    valid = false;

                    placeholder = $(this).attr('placeholder');
                    msg += "<p>" + placeholder + " is empty</p>";
                    $(this).addClass('attention');
                }
            });

            $('.js-card-field').each(function () {

                if ($(this).val() == 'incomplete') {
                    valid = false;

                    placeholder = $(this).attr('placeholder');
                    msg += "<p>" + placeholder + " is only partially complete</p>";
                }

                if ($(this).val() == 'error') {
                    valid = false;

                    error = $(this).attr('data-error');
                    msg += "<p>" + error + "</p>";

                    $(this).markCardFieldForAttention();
                }

            });
        }

        if (!isValidEmailAddress($('input[name=email]').val())) {
            valid = false;
            error_msg += "<li>Please provide a valid email address</li>";
        }

        if (!valid) {
            error_msg += msg;
        }

        if (button.hasClass('loading')) {
            valid = false;
            error_msg += "<li>Checkout already in progress</li>";
        }

        if (valid) {
            button.addClass('loading').find('span').attr('data-original-text', button.text()).text('Please wait...');

            if ($('.js-payment-type:checked').val() == 1) {
                //Card order via Stripe
                console.log('Is Stripe');

                if (valid) {

                    console.log('stripe.createPaymentMethod()');

                    name_on_card = $('.js-name-on-card').val();

                    stripe.createPaymentMethod('card', cardNumber, {
                        billing_details: {
                            name: name_on_card
                        }
                    }).then(function (result) {

                        console.log('stripe.createPaymentMethod() -> then');

                        if (result.error) {
                            valid = false;
                            console.log(result);
                            msg += "Stripe error occurred, unable to create payment method: " + result.error.message;
                            Apprise(msg);
                            $('.js-pay-now').removeClass('loading').find('span').text('Try again');
                        } else {

                            //Attempt to confirm payment (check for 3D secure requirements, etc)

                            // Otherwise send paymentMethod.id to your server (see Step 2)
                            fetch('../../php/ajax/stripe--confirm-payment.php', {
                                method: 'POST',
                                headers: {'Content-Type': 'application/json'},
                                body: JSON.stringify({
                                    payment_method_id: result.paymentMethod.id,
                                    customer: getCheckoutDetails()
                                })
                            }).then(function (result) {
                                // Handle server response (see Step 3)
                                return result.json();
                            }).then(handleServerResponse, handleUnreadablePaymentResponse);
                        }
                    });

                }

            } else if ($('.js-payment-type:checked').val() == 2) {
                //PayPal order
                console.log('Is PayPal');
                createPayPalOrder();
            }
        } else {
            error_msg = "<h1>Before you finish...</h1><ul>" + error_msg + "</ul>";
            Apprise(error_msg, default_apprise_options);
        }
    });

    //
    $('.checkout .continue').on('click', function (e) {

        e.preventDefault();

        if ($(window).width() <= 990) {
            scrollToTop();
        }

        //validation
        msg = "";
        valid = true;
        error_msg = "";

        //
        form = $(this).closest('div');

        //check required fields
        form.checkRequiredFields();

        if (!valid) {
            error_msg += msg;
        }

        //
        if (valid) {
            $('.step-1').slideUp();
            $('.step-2').slideDown();
        } else {
            error_msg = "<h1>Before you finish...</h1><ul>" + error_msg + "</ul>";

            Apprise(error_msg, default_apprise_options);
        }
    });

    //
    $('.add-to-basket').on('click', function (e) {

        e.preventDefault();

        quantity = $('select.quantity').val();
        size_id = $('select.size').val();
        size_title = $('select.size option:selected').text();
        product_id = $('input[name=product_id]').val();
        product_title = $('.product .column-2 > h1').text();

        //validation
        msg = "";
        valid = true;
        error_msg = "";

        //
        form = $(this).closest('div');

        //check required fields
        form.checkRequiredFields();

        if (!valid) {
            error_msg += msg;
        }

        //
        if (valid) {
            post_data = {
                quantity: quantity,
                size_id: size_id,
                product_id: product_id
            };

            url = "../php/ajax/basket.php?action=add-product";

            $('.add-to-basket').attr('data_original-text', $('.add-to-basket').text());
            $('.add-to-basket').text('Please wait...');

            $.post(url, post_data, function (data) {

                try {
                    response = JSON.parse(data);

                    if (response.success) {

                        var options = {
                            override: false,
                            buttons: {

                                checkout: {
                                    text: 'Checkout now',
                                    className: 'checkout main',
                                    action: function (e) {
                                        location.href = "/checkout";
                                    }
                                },

                                continue: {
                                    text: 'Or continue shopping?',
                                    className: 'continue small',
                                    action: function (e) {
                                        Apprise('close');
                                    }
                                }
                            }
                        };

                        confirmation = "<h1>You’ve added " + quantity + " &times; " + product_title + " to your basket. Thanks!</h1>";

                        Apprise(confirmation, options);

                        old_qty = parseInt($('.links .basket em').html());
                        to_add = parseInt(quantity);
                        basket_count = old_qty + to_add;

                        $('.links .basket em').text(basket_count);

                        $('.add-to-basket').text($('.add-to-basket').attr('data_original-text'));

                    } else {
                        valid = false;
                        error_msg += response.error_message;
                        Apprise(error_msg);

                        $('.add-to-basket').text($('.add-to-basket').attr('data_original-text'));
                    }
                } catch (e) {
                    valid = false;
                    error_msg += "<li>Technical error: " + data + "</li>";
                    Apprise(error_msg);

                    $('.add-to-basket').text($('.add-to-basket').attr('data_original-text'));
                }

            });

        } else {
            error_msg = "<h1>Before you finish...</h1><ul>" + error_msg + "</ul>";
            Apprise(error_msg, default_apprise_options);
        }

    });

    $('.remove-from-basket').on('click', function (e) {
        post_data = {
            size_id: $(this).data('size_id'),
            product_id: $(this).data('product_id')
        };

        url = "../php/ajax/basket.php?action=delete-product";

        $.post(url, post_data, function (data) {
            try {
                response = JSON.parse(data);

                if (response.success) {
                    location.reload();
                } else {
                    valid = false;
                    error_msg += response.error_message;
                    Apprise(error_msg);
                }
            } catch (e) {
                valid = false;
                error_msg += "<li>Technical error: " + data + "</li>";
                Apprise(error_msg);
            }

        });

    });

    $('input[name=show_voucher]').on('change', function () {
        if ($(this).prop('checked')) {
            $('.voucher_container').removeClass('hidden');
        } else {
            $('.voucher_container').addClass('hidden');
        }
    });

    $('.js-apply-voucher').on('click', function (e) {

        e.preventDefault();

        var voucher_code = $('.js-voucher-code').val();

        msg = "";
        valid = true;
        error_msg = "";

        if (voucher_code != '') {
            post_data = {
                voucher_code: voucher_code,
            };

            url = "../php/ajax/basket.php?action=add-voucher";

            $.post(url, post_data, function (data) {

                try {
                    response = JSON.parse(data);

                    if (response.success) {
                        location.reload();
                    } else {
                        valid = false;
                        error_msg += response.error_message;
                        Apprise(error_msg);
                    }
                } catch (e) {
                    valid = false;
                    error_msg += "<li>Technical error: " + data + "</li>";
                    Apprise(error_msg);
                }

            });

        }
    });

    $('.delete_voucher').on('click', function (e) {

        e.preventDefault();

        msg = "";
        valid = true;
        error_msg = "";

        url = "../php/ajax/basket.php?action=delete-voucher";

        $.post(url, {}, function (data) {

            try {
                response = JSON.parse(data);

                if (response.success) {
                    location.reload();
                } else {
                    valid = false;
                    error_msg += response.error_message;
                    Apprise(error_msg);
                }
            } catch (e) {
                valid = false;
                error_msg += "<li>Technical error: " + data + "</li>";
                Apprise(error_msg);
            }

        });
    });

});


//The customer's details from the checkout form - sent with the card payment so the server can create the order
//in the same request that takes the money
function getCheckoutDetails() {

    return {
        name: $('input[name=name]').val(),
        address: $('input[name=address]').val(),
        towncity: $('input[name=towncity]').val(),
        postcode: $('input[name=postcode]').val(),
        delivery_note: $('input[name=delivery_note]').val(),
        email: $('input[name=email]').val(),
        phone: $('input[name=phone]').val(),
        mobile: $('input[name=mobile]').val(),
        mailing_list: $('input[name=mailing_list]').is(':checked') ? 1 : 0
    };
}

function checkoutOrder(paypal, intent_id) {

    console.log('checkoutOrder()');

    if (paypal == "") {
        paypal = 0;
    }

    post_data = $.extend(getCheckoutDetails(), {
        stripeToken: $('input[name=stripeToken]').val(),
        paypal: paypal,
        intent_id: intent_id
    });

    url = "../php/ajax/basket.php?action=checkout";

    $.post(url, post_data, function (data) {

        console.log(data);

        try {
            response = JSON.parse(data);
            console.log(response);

            if (response.success) {

                if (response.paypal == 1) {
                    paypal_url = response.paypal_url;
                    location.href = paypal_url;
                } else {
                    location.href = 'order-confirmation';
                }
            } else {
                valid = false;

                error_msg = "<h1>Sorry, There was a problem processing your payment</h1>" + response.error_message + " #A";

                Apprise(error_msg);

                $('.js-pay-now').removeClass('loading').find('span').text($('.js-pay-now').find('span').attr('data-original-text'));
            }
        } catch (e) {
            valid = false;
            error_msg += "<li>Technical error: " + data + "</li>";
            Apprise(error_msg);

            $('.js-pay-now').removeClass('loading').find('span').text($('.js-pay-now').find('span').attr('data-original-text'));
        }

    });
}

function createPayPalOrder() {

    console.log('createPayPalOrder()');

    checkoutOrder(1);

}

function handleServerResponse(response) {
    console.log('handleServerResponse()');
    console.log(response);
    if (response.payment_taken) {
        // The card was charged but the order couldn't be finalised - the shop has been emailed. Leave the button
        // disabled so the customer isn't charged again
        Apprise("<h2>Thank you, your payment has been received</h2>" + response.error);
        $('.js-pay-now').find('span').text('Payment received');
    } else if (response.error) {
        Apprise("<h2>There was a problem processing your payment</h2>" + (response.error.message || response.error) + " #B");
        $('.js-pay-now').removeClass('loading').find('span').text('Try again');
        // Show error from server on payment form
    } else if (response.order_id) {
        // Payment taken and order created by the server
        location.href = 'order-confirmation';
    } else if (response.requires_action) {
        // Use Stripe.js to handle required card action
        stripe.handleCardAction(
            response.payment_intent_client_secret
        ).then(function (result) {
            console.log(result);
            if (result.error) {
                // Show error in payment form
                Apprise("<h2>There was a problem processing your payment</h2>" + result.error.message + " #C");
                $('.js-pay-now').removeClass('loading').find('span').text('Try again');
            } else {
                // The card action has been handled
                // The PaymentIntent can be confirmed again on the server
                fetch('../../php/ajax/stripe--confirm-payment.php', {
                    method: 'POST',
                    headers: {'Content-Type': 'application/json'},
                    body: JSON.stringify({
                        payment_intent_id: result.paymentIntent.id,
                        customer: getCheckoutDetails()
                    })
                }).then(function (confirmResult) {
                    return confirmResult.json();
                }).then(handleServerResponse, handleUnreadablePaymentResponse);
            }
        });
    } else {
        // Payment taken by a server that doesn't create the order itself (only while a deploy is in progress)
        checkoutOrder(0, response.intent_id);
    }
}

// The payment request failed or returned something unreadable, so we can't tell whether the card was charged -
// don't invite the customer to pay again
function handleUnreadablePaymentResponse(error) {
    console.log(error);
    Apprise("<h2>Sorry, something went wrong</h2><p>We couldn't confirm whether your payment went through. Please don't pay again - contact us and we'll check it for you.</p>");
    $('.js-pay-now').find('span').text('Please contact us');
}
